import { type CheckboxProps } from '@mantine/core';
import { BooleanInput } from '../../inputs/BooleanInput';
import { useEditorContext } from '../EditorContext';
import type { LooseKeys } from '../types';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalBooleanItemProps<TFormType> extends Omit<CheckboxProps, 'checked' | 'onChange'> {
    fieldKey: LooseKeys<TFormType>;
    required?: boolean;
    label?: string;
    labelWidth?: number;
}

export const ModalBooleanItem = <TFormType,>({
    fieldKey,
    required,
    label,
    labelWidth,
    ...checkboxProps
}: ModalBooleanItemProps<TFormType>) => {
    const { form, loading, onSave } = useEditorContext<TFormType>();

    const fieldKeyString = fieldKey as string;
    const error = form.errors[fieldKeyString];

    return (
        <ModalEditorItemBase
            label={label}
            labelWidth={labelWidth}
            error={error}
            required={required}
            submitChanges={onSave}
        >
            <BooleanInput
                key={form.key(fieldKeyString)}
                {...form.getInputProps(fieldKeyString, { type: 'checkbox' })}
                disabled={loading}
                {...checkboxProps}
            />
        </ModalEditorItemBase>
    );
};
